export default __webpack_public_path__ + "static/media/logo.bed5e217.png";